import { Monitor } from 'lucide-react';
import { useCopy, fill } from '../../i18n';
import { useUIState } from '../../contexts/UIStateContext';
import EmptyState from './EmptyState';

interface DesktopOnlyModuleProps {
  /** Nome do módulo, já traduzido, para a frase dizer de quem está falando. */
  moduleName: string;
}

/**
 * O que aparece no celular no lugar de um módulo que só funciona no computador.
 *
 * A alternativa era renderizar a tela densa mesmo assim e deixar o usuário
 * lidar com uma grade de dez colunas em 375px. Isso não é neutro: ele conclui
 * que o produto é quebrado, não que aquela tela é de planejamento. Dizer a
 * verdade e oferecer o caminho útil custa menos do que a má impressão.
 *
 * O corte é o mesmo de Trello, Asana e Jira: o telefone serve para EXECUTAR
 * (ver o que é meu, mover cartão, comentar), e o planejamento (Gantt, EAP,
 * custos, portfólio) fica no computador, onde há tela para a decisão.
 *
 * O botão leva a Minhas Tarefas, e não fecha nada: estado vazio sem saída é
 * beco, e quem chegou aqui num link ficaria preso.
 */
const DesktopOnlyModule = ({ moduleName }: DesktopOnlyModuleProps) => {
  const t = useCopy().common.desktopOnly;
  const { changeModule } = useUIState();

  return (
    <EmptyState
      icon={Monitor}
      title={fill(t.title, { module: moduleName })}
      description={t.description}
      actionLabel={t.action}
      onAction={() => changeModule('hoje')}
    />
  );
};

export default DesktopOnlyModule;
